define('Store.HandlebarsHelper.StoreBasedCMSArea', [
    'Handlebars',
    'underscore',
    'Profile.Model'
], function HandlebarsHelperStoreBasedCMSArea(
    Handlebars,
    _,
    ProfileModel
) {
    'use strict';

    Handlebars.registerHelper('storeBasedCMSArea', function customerCategoryCMSArea(area, filters, id, className, options) {
        var profile = ProfileModel.getInstance();
        var store = profile.get('store') || {};
        var areaName = area + (store.get && store.get('internalid') ? '_' + store.get('internalid') : '');
        var cmsArea = '<div data-cms-area="' + areaName + '" data-cms-area-filters="' + filters + '" ';
        if (id) {
            cmsArea += 'id="' + id + '" ';
        }

        if (className) {
            cmsArea += 'class="' + className + '" ';
        }

        if (options.fn) {
            cmsArea += '>' + options.fn() + '</div>';
        } else {
            cmsArea += '></div>';
        }
        return new Handlebars.SafeString(cmsArea);
    });
});
